import { AppState } from "@Store/index";
import { useSelector, shallowEqual } from "react-redux";

const useIsRedirect = () => {
  const { isInternalUser, isDesktop } = useSelector(
    ({ appData }: AppState) => ({
      isInternalUser: appData.isInternalUser,
      isDesktop: appData.isDesktop,
    }),
    shallowEqual,
  );
  return isDesktop && isInternalUser;
};

export default useIsRedirect;
